import React from "react";

import Eco_Chap1_Theme1_1 from "../chapter1/theme1/Eco_Chap1_Theme1_1";
import Eco_Chap1_Theme1_2 from "../chapter1/theme1/Eco_Chap1_Theme1_2";
import Eco_Chap1_Theme1_2_1 from "../chapter1/theme1/Eco_Chap1_Theme1_2_1";
import Eco_Chap1_Theme1_3 from "../chapter1/theme1/Eco_Chap1_Theme1_3";
import Eco_Chap1_Theme1_4 from "../chapter1/theme1/Eco_Chap1_Theme1_4";
import Eco_Chap1_Theme1_5 from "../chapter1/theme1/Eco_Chap1_Theme1_5";
import Eco_Chap1_Theme1_5_1 from "../chapter1/theme1/Eco_Chap1_Theme1_5_1";
import Eco_Chap1_Theme1_5_2 from "../chapter1/theme1/Eco_Chap1_Theme1_5_2";
import Eco_Chap1_Theme1_6 from "../chapter1/theme1/Eco_Chap1_Theme1_6";
import Eco_Chap1_Theme1_7 from "../chapter1/theme1/Eco_chap1_theme1_7";
import Eco_Chap1_Theme1_8 from "../chapter1/theme1/Eco_Chap1_Theme1_8";
import Eco_Chap1_Theme1_9 from "../chapter1/theme1/Eco_Chap1_Theme1_9";
import Eco_Chap1_Theme1_10 from "../chapter1/theme1/Eco_Chap1_Theme1_10";
import Eco_Chap1_Theme1_11 from "../chapter1/theme1/Eco_Chap1_Theme1_11";
import Eco_Chap1_Theme1_12 from "../chapter1/theme1/Eco_Chap1_Theme1_12";
import EcoChap1Theme2_1 from "../chapter1/theme2/Eco_Сhap1_Theme2_1";
// import Eco_Chap1_Theme2_2 from "../chapter1/theme2/Eco_Chap1_Theme2_2";
import Eco_Chap1_Theme2_3 from "../chapter1/theme2/Eco_Chap1_Theme2_3";
import Eco_Chap1_Theme2_4 from "../chapter1/theme2/Eco_Chap1_Theme2_4";
import Eco_Chap1_Theme2_5 from "../chapter1/theme2/Eco_Chap1_Theme2_5";
import Eco_Chap1_Theme2_6 from "../chapter1/theme2/Eco_Chap1_Theme2_6";
import Eco_Chap1_Theme2_7 from "../chapter1/theme2/Eco_Chap1_Theme2_7";
import EcoChap1Theme3_1 from "../chapter1/theme3/EcoChap1Theme3_1";
import EcoChap1Theme3_2 from "../chapter1/theme3/EcoChap1Theme3_2";
import EcoChap1Theme3_3 from "../chapter1/theme3/EcoChap1Theme3_3";
import EcoChap1Theme3_4 from "../chapter1/theme3/EcoChap1Theme3_4";
import EcoChap1Theme3_5 from "../chapter1/theme3/EcoChap1Theme3_5";
import EcoChap1Theme3_6 from "../chapter1/theme3/EcoChap1Theme3_6";

import Eco_Chap2_Theme1_1 from "../chapter2/theme1/Eco_Chap2_Theme1_1";
import Eco_Chap2_Theme1_2 from "../chapter2/theme1/Eco_Chap2_Theme1_2";
import Eco_Chap2_Theme1_3 from "../chapter2/theme1/Eco_Chap2_Theme1_3";
import Eco_Chap2_Theme1_4 from "../chapter2/theme1/Eco_Chap2_Theme1_4";
import Eco_Chap2_Theme2_1 from "../chapter2/theme2/Eco_Chap2_Theme2_1";
import Eco_Chap2_Theme2_2 from "../chapter2/theme2/Eco_Chap2_Theme2_2";
import Eco_Chap2_Theme3_1 from "../chapter2/theme3/Eco_Chap2_Theme3_1";
import Eco_Chap2_Theme4_1 from "../chapter2/theme4/Eco_Chap2_Theme4_1";
import Eco_Chap2_Theme4_2 from "../chapter2/theme4/Eco_Chap2_Theme4_2";
import Eco_Chap2_Theme4_3 from "../chapter2/theme4/Eco_Chap2_Theme4_3";
import Eco_Chap2_Theme4_4 from "../chapter2/theme4/Eco_Chap2_Theme4_4";
import Eco_Chap2_Theme4_5 from "../chapter2/theme4/Eco_Chap2_Theme4_5";
import Eco_Chap2_Theme4_6 from "../chapter2/theme4/Eco_Chap2_Theme4_6";
import Eco_Chap2_Theme4_7 from "../chapter2/theme4/Eco_Chap2_Theme4_7";
import Eco_Chap2_Theme4_8 from "../chapter2/theme4/Eco_Chap2_Theme4_8";
import Eco_Chap2_Theme4_9 from "../chapter2/theme4/Eco_Chap2_Theme4_9";
import Eco_Chap2_Theme4_10 from "../chapter2/theme4/Eco_Chap2_Theme4_10";
import Eco_Chap2_Theme4_11 from "../chapter2/theme4/Eco_Chap2_Theme4_11";
import Eco_Chap2_Theme5_1 from "../chapter2/theme5/Eco_Chap2_Theme5_1";
import Eco_Chap2_Theme5_2 from "../chapter2/theme5/Eco_Chap2_Theme5_2";
import Eco_Chap2_Theme5_3 from "../chapter2/theme5/Eco_Chap2_Theme5_3";
import Eco_Chap2_Theme5_4 from "../chapter2/theme5/Eco_Chap2_Theme5_4";
import Eco_Chap2_Theme5_5 from "../chapter2/theme5/Eco_Chap2_Theme5_5";
import Eco_Chap2_Theme5_6 from "../chapter2/theme5/Eco_Chap2_Theme5_6";

import Eco_Chap3_Theme2_1 from "../chapter3/theme2/Eco_Chap3_Theme2_1";
import Eco_Chap3_Theme2_2 from "../chapter3/theme2/Eco_Chap3_Theme2_2";
import Eco_Chap3_Theme1_1 from "../chapter3/theme1/Eco_Chap3_Theme1_1";
import Eco_Chap3_Theme1_2 from "../chapter3/theme1/Eco_Chap3_Theme1_2";
import Eco_Chap3_Theme1_3 from "../chapter3/theme1/Eco_Chap3_Theme1_3";
import Eco_Chap3_Theme1_4 from "../chapter3/theme1/Eco_Chap3_Theme1_4";
import Eco_Chap3_Theme1_5 from "../chapter3/theme1/Eco_Chap3_Theme1_5";
import Eco_Chap3_Theme1_6 from "../chapter3/theme1/Eco_Chap3_Theme1_6";
import Eco_Chap3_Theme1_7 from "../chapter3/theme1/Eco_Chap3_Theme1_7";
import Eco_Chap3_Theme1_8 from "../chapter3/theme1/Eco_Chap3_Theme1_8";


export class FirstChapter {
    id = 1;
    name = 'Законодательная база в области охраны окружающей среды и экологической безопасности';
    themes = [
        [
            <Eco_Chap1_Theme1_1/>,   <Eco_Chap1_Theme1_2/>,
            <Eco_Chap1_Theme1_2_1/>, <Eco_Chap1_Theme1_3/>,
            <Eco_Chap1_Theme1_4/>,   <Eco_Chap1_Theme1_5/>,
            <Eco_Chap1_Theme1_5_1/>, <Eco_Chap1_Theme1_5_2/>,
            <Eco_Chap1_Theme1_6/>,   <Eco_Chap1_Theme1_7/>,
            <Eco_Chap1_Theme1_8/>,   <Eco_Chap1_Theme1_9/>,
            <Eco_Chap1_Theme1_10/>,  <Eco_Chap1_Theme1_11/>,
            <Eco_Chap1_Theme1_12/>,
        ],
        [
            // <EcoChap1Theme2_1/>,     <Eco_Chap1_Theme2_2/>,
            <EcoChap1Theme2_1/>,     <Eco_Chap1_Theme2_3/>,
            <Eco_Chap1_Theme2_4/>,   <Eco_Chap1_Theme2_5/>,
            <Eco_Chap1_Theme2_7/>,   <Eco_Chap1_Theme2_7/>,
        ],
        [
            <EcoChap1Theme3_1/>, <EcoChap1Theme3_2/>,
            <EcoChap1Theme3_3/>, <EcoChap1Theme3_4/>,
            <EcoChap1Theme3_5/>, <EcoChap1Theme3_6/>,
        ],
    ];
    titles = [
        [
            '1.1 Федеральный закон от 10.01.2002 N 7-ФЗ "Об охране окружающей среды"',
            '1.2 Федеральный закон от 04.05.1999 N 96-ФЗ "Об охране атмосферного воздуха"',
            '1.3 Федеральный закон от 04.05.1999 N 96-ФЗ "Об охране атмосферного воздуха"',
            '1.4 Федеральный закон от 30.03.1999 N 52-ФЗ (ред. от 02.07.2021) "О санитарно-эпидемиологическом благополучии населения"',
            '1.5 Права и обязанности граждан, индивидуальных предпринимателей и юридических лиц',
            '1.6 Категорийность объектов по степени негативного воздействия на окружающую среду',
            '1.7 Категорийность объектов по степени негативного воздействия на окружающую среду',
            '1.8 Категорийность объектов по степени негативного воздействия на окружающую среду',
            '1.9 Требования к обращению с отходами I - V классов опасности. Федеральный закон от 24.06.1998 N 89-ФЗ',
            '1.10 Паспортизация отходов. Приказ Минприроды России от 08.12.2020 N 1026',
            '1.11 Федеральный оператор по обращению с отходами I и II классов опасности. Федеральный закон от 24.06.1998 N 89-ФЗ',
            '1.12 Федеральная схема обращения с отходами I и II классов опасности. Федеральный закон от 24.06.1998 N 89-ФЗ',
            '1.13 Особенности обращения с отходами I и II классов опасности. Федеральный закон от 24.06.1998 N 89-ФЗ',
            '1.14 Предоставление информации индивидуальными предпринимателями и юридическими лицами',
            '1.15 Декларация по НВОС',
        ],
        [
            '2.1 Система государственного управления в области охраны окружающей среды',
            // '2.2 Производственный экологический контроль в области обращения с отходами производства и потребления',
            '2.2 Негативное воздействие на окружающую среду при размещении отходов',
            '2.3 Производственный экологический контроль',
            '2.4 Плата за негативное воздействие на окружающую среду',
            '2.5 Производственный контроль в области охраны окружающей среды',
            '2.6 Отчет об организации и о результатах осуществления производственного экологического контроля',
        ],
        [
            '3.1 Организационно-распорядительные документы',
            '3.2 Документация по охране атмосферного воздуха',
            '3.3 Документация по охране водных объектов',
            '3.4 Документация по обращению с отходами',
            '3.5 Государственная статистическая отчетность',
            '3.6 Статистическая отчетность предприятия',
        ],
    ];
    getSelectedMenuItem = (themes, currentPage, switchToGlossary, switchToLiterature, switchToMaterials, switchToSkeleton) => {
        if(!switchToGlossary && !switchToLiterature && !switchToMaterials && !switchToSkeleton) {
            switch (currentPage) {
                case themes[0][0]: return('11');
                case themes[0][1]: return('12');
                case themes[0][2]: return('12');
                case themes[0][3]: return('13');
                case themes[0][4]: return('14');
                case themes[0][5]: return('15');
                case themes[0][6]: return('15');
                case themes[0][7]: return('15');
                case themes[0][8]: return('16');
                case themes[0][9]: return('17');
                case themes[0][10]: return('18');
                case themes[0][11]: return('19');
                case themes[0][12]: return('20');
                case themes[0][13]: return('21');
                case themes[0][14]: return('22');

                case themes[1][0]: return('111');
                case themes[1][1]: return('112');
                case themes[1][2]: return('113');
                case themes[1][3]: return('114');
                case themes[1][4]: return('115');
                case themes[1][5]: return('116');
                // case themes[1][6]: return('117');

                case themes[2][0]: return('121');
                case themes[2][1]: return('122');
                case themes[2][2]: return('123');
                case themes[2][3]: return('124');
                case themes[2][4]: return('125');
                case themes[2][5]: return('126');
            }
        } else {
            if (switchToGlossary) return '4';
            if (switchToLiterature) return '5';
            if (switchToMaterials) return '6';
            if (switchToSkeleton) return '7';
        }
    }
}

export class SecondChapter {
    id = 2;
    name = 'Производственный экологический контроль на предприятиях';
    themes = [
        [
            // <Eco_Chap2_Theme1_1/>,   <Eco_Chap2_Theme1_2/>,
            <Eco_Chap2_Theme1_2/>,
            <Eco_Chap2_Theme1_3/>,   <Eco_Chap2_Theme1_4/>,
        ],
        [
            <Eco_Chap2_Theme2_1/>,   <Eco_Chap2_Theme2_2/>,
        ],
        [
            <Eco_Chap2_Theme3_1/>,
        ],
        [
            <Eco_Chap2_Theme4_1/>,   <Eco_Chap2_Theme4_2/>,
            <Eco_Chap2_Theme4_3/>,   <Eco_Chap2_Theme4_4/>,
            <Eco_Chap2_Theme4_5/>,   <Eco_Chap2_Theme4_6/>,
            <Eco_Chap2_Theme4_7/>,   <Eco_Chap2_Theme4_8/>,
            <Eco_Chap2_Theme4_9/>,   <Eco_Chap2_Theme4_10/>,
            <Eco_Chap2_Theme4_11/>,
        ],
        [
            <Eco_Chap2_Theme5_1/>,   <Eco_Chap2_Theme5_2/>,
            <Eco_Chap2_Theme5_3/>,   <Eco_Chap2_Theme5_4/>,
            <Eco_Chap2_Theme5_5/>,   <Eco_Chap2_Theme5_6/>,
        ],
    ];
    titles = [
        [
            // '1.1 Производственный экологический контроль',
            '1.1 Основные требования экологического контроля',
            '1.2 Категории экологического контроля',
            '1.3 Проведение производственного экологического контроля',
        ],
        [
            '2.1 Требования к предприятиям',
            '2.2 Требования охраны атмосферного воздуха',
        ],
        [
            '3.1 Требования, предъявляемые законодательством в области рационального использования и охраны водных объектов',
        ],
        [
            '4.1 Порядок отнесения отходов к классу опасности для окружающей среды',
            '4.2 Требования к лицам, которые допущены к отходам I - IV классов опасности',
            '4.3 Полномочия органов местного самоуправления в области обращения с твердыми коммунальными отходами',
            '4.4 Основные требования обращения с отходами',
            '4.5 Порядок учета, транспортирования отходов',
            '4.6 Необходимость разработки ПНООЛР',
            '4.7 Порядок разработки и утверждения нормативов образования отходов и лимитов на их размещение',
            '4.8 Разработка проектов нормативов образования отходов и лимитов на их размещение',
            '4.9 Методы определения нормативов образования отходов',
            '4.10 Содержание и оформление нормативов образования отходов и лимитов на их размещение',
            '4.11 Процедура оформления лицензии на деятельность. Лицензирование.',
        ],
        [
            '5.1 Общие вопросы исчисления и уплаты платы за негативное воздействие на окружающую среду',
            '5.2 Плата за размещение отходов и выбросы загрязняющих веществ в атмосферный воздух',
            '5.3 Коэффициенты к ставкам платы',
            '5.4 Правила исчисления и взимания платы за негативное воздействие на окружающую среду',
            '5.5 Исчисление и взимание платы за негативное воздействие на окружающую среду',
            '5.6 Административная ответственность',
        ],
    ];
    getSelectedMenuItem = (themes, currentPage, switchToGlossary, switchToLiterature, switchToMaterials, switchToSkeleton) => {
        if(!switchToGlossary && !switchToLiterature && !switchToMaterials && !switchToSkeleton) {
            switch (currentPage) {
                case themes[0][0]: return('211');
                case themes[0][1]: return('212');
                case themes[0][2]: return('213');
                // case themes[0][3]: return('214');

                case themes[1][0]: return('221');
                case themes[1][1]: return('222');

                case themes[2][0]: return('231');

                case themes[3][0]: return('241');
                case themes[3][1]: return('242');
                case themes[3][2]: return('243');
                case themes[3][3]: return('244');
                case themes[3][4]: return('245');
                case themes[3][5]: return('246');
                case themes[3][6]: return('247');
                case themes[3][7]: return('248');
                case themes[3][8]: return('249');
                case themes[3][9]: return('2410');
                case themes[3][10]: return('2411');

                case themes[4][0]: return('251');
                case themes[4][1]: return('252');
                case themes[4][2]: return('253');
                case themes[4][3]: return('254');
                case themes[4][4]: return('255');
                case themes[4][5]: return('256');
            }
        } else {
            if (switchToGlossary) return '4';
            if (switchToLiterature) return '5';
            if (switchToMaterials) return '6';
            if (switchToSkeleton) return '7';
        }
    }
}

export class ThirdChapter {
    id = 3;
    name = 'Государственный экологический надзор';
    themes = [
        [
            <Eco_Chap3_Theme1_1/>,   <Eco_Chap3_Theme1_2/>,
            <Eco_Chap3_Theme1_3/>,   <Eco_Chap3_Theme1_4/>,
            <Eco_Chap3_Theme1_5/>,   <Eco_Chap3_Theme1_6/>,
            <Eco_Chap3_Theme1_7/>,   <Eco_Chap3_Theme1_8/>,
        ],
        [
            <Eco_Chap3_Theme2_1/>,   <Eco_Chap3_Theme2_2/>,
        ],
    ];
    titles = [
        [
            '1.1 Обеспечение экологической безопасности при обращении с опасными отходами',
            '1.2 Общественный контроль',
            '1.3 Государственный экологический надзор',
            '1.4 Права должностных лиц органов государственного экологического надзора. Объекты государственного экологического надзора',
            '1.5 Действия эколога при проведении проверки предприятия',
            '1.6 Организация и проведение проверок',
            '1.7 Порядок организации проверки',
            '1.8 Порядок оформления результатов проверки',
        ],
        [
            '2.1 Административная ответственность за совершение экологических правонарушений',
            '2.2 Экологические преступления',
        ],
    ];
    getSelectedMenuItem = (themes, currentPage, switchToGlossary, switchToLiterature, switchToMaterials, switchToSkeleton) => {
        if(!switchToGlossary && !switchToLiterature && !switchToMaterials && !switchToSkeleton) {
            switch (currentPage) {
                case themes[0][0]: return('111');
                case themes[0][1]: return('112');
                case themes[0][2]: return('113');
                case themes[0][3]: return('114');
                case themes[0][4]: return('115');
                case themes[0][5]: return('116');
                case themes[0][6]: return('117');
                case themes[0][7]: return('118');

                case themes[1][0]: return('121');
                case themes[1][1]: return('122');
            }
        } else {
            if (switchToGlossary) return '4';
            if (switchToLiterature) return '5';
            if (switchToMaterials) return '6';
            if (switchToSkeleton) return '7';
        }
    }
}